import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGameController = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 25 25",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0.75 0.75)",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: [/* @__PURE__ */ _jsx("g", {
			transform: "translate(0 5)",
			children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("path", { d: "M10.8,12.3c-3.9,0-3.2,5.9-6.9,5.9c-2.1-0.1-3.8-1.9-3.7-4c0,0,0-0.1,0-0.1V7.3 c0-3.9,3.1-7,7-7h9c3.9,0,7,3.1,7,7v6.8c0.2,2.1-1.4,4-3.5,4.1c0,0-0.1,0-0.1,0c-3.7,0-3-5.9-6.9-5.9H10.8z" }),
				/* @__PURE__ */ _jsx("path", { d: "M6.2,4.9v4.8" }),
				/* @__PURE__ */ _jsx("path", { d: "M8.6,7.3H3.8" }),
				/* @__PURE__ */ _jsx("path", { d: "M17.2,5.1c0.1,0,0.2,0.1,0.2,0.2" }),
				/* @__PURE__ */ _jsx("path", { d: "M17,5.3c0-0.1,0.1-0.2,0.2-0.2" }),
				/* @__PURE__ */ _jsx("path", { d: "M17.2,5.6c-0.1,0-0.2-0.1-0.2-0.2" }),
				/* @__PURE__ */ _jsx("path", { d: "M17.5,5.3c0,0.1-0.1,0.2-0.2,0.2" }),
				/* @__PURE__ */ _jsx("path", { d: "M15.2,7.1c0.1,0,0.2,0.1,0.2,0.2" }),
				/* @__PURE__ */ _jsx("path", { d: "M15,7.3c0-0.1,0.1-0.2,0.2-0.2" }),
				/* @__PURE__ */ _jsx("path", { d: "M15.2,7.6c-0.1,0-0.2-0.1-0.2-0.2" }),
				/* @__PURE__ */ _jsx("path", { d: "M15.5,7.3c0,0.1-0.1,0.2-0.2,0.2" }),
				/* @__PURE__ */ _jsx("path", { d: "M17.2,9.1c0.1,0,0.2,0.1,0.2,0.2" }),
				/* @__PURE__ */ _jsx("path", { d: "M17,9.3c0-0.1,0.1-0.2,0.2-0.2" }),
				/* @__PURE__ */ _jsx("path", { d: "M17.2,9.6c-0.1,0-0.2-0.1-0.2-0.2" }),
				/* @__PURE__ */ _jsx("path", { d: "M17.5,9.3c0,0.1-0.1,0.2-0.2,0.2" }),
				/* @__PURE__ */ _jsx("path", { d: "M19.2,7.1c0.1,0,0.2,0.1,0.2,0.2" }),
				/* @__PURE__ */ _jsx("path", { d: "M19,7.3c0-0.1,0.1-0.2,0.2-0.2" }),
				/* @__PURE__ */ _jsx("path", { d: "M19.2,7.6c-0.1,0-0.2-0.1-0.2-0.2" }),
				/* @__PURE__ */ _jsx("path", { d: "M19.5,7.3c0,0.1-0.1,0.2-0.2,0.2" })
			] }) })
		}), /* @__PURE__ */ _jsx("path", { d: "M6.2,0.3c2.8,0,5,2.2,5,5" })]
	})
});
export { SvgGameController as ReactComponent };
